// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for rich text messages in overlay chat */
.rich-text-message {
    color: inherit;
    line-height: 1.4;
}

.rich-text-message strong {
    font-weight: bold;
    color: inherit;
}

.rich-text-message em {
    font-style: italic;
    color: inherit;
}

.rich-text-message u {
    text-decoration: underline;
    color: inherit;
}

.rich-text-message code {
    background-color: rgba(255, 255, 255, 0.1);
    color: #ff6b6b;
    padding: 2px 4px;
    border-radius: 4px;
    font-family: Monaco, Consolas, "Courier New", monospace;
    font-size: 0.85em;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.rich-text-message pre {
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    padding: 12px;
    border-radius: 6px;
    font-family: Monaco, Consolas, "Courier New", monospace;
    font-size: 0.9em;
    overflow: auto;
    border: 1px solid rgba(255, 255, 255, 0.2);
    margin: 8px 0;
    white-space: pre-wrap;
}

.rich-text-message pre code {
    background-color: transparent;
    padding: 0;
    border-radius: 0;
    border: none;
    color: inherit;
}

.rich-text-message ul, .rich-text-message ol {
    padding: 0 0 0 20px;
    margin: 8px 0;
}

.rich-text-message li {
    margin: 2px 0;
}

.rich-text-message p {
    margin: 0 0 8px 0;
}

.rich-text-message p:last-child {
    margin-bottom: 0;
}

/* Styles pour la coloration syntaxique - Messages Shiki */
.rich-text-message pre {
    background: #2d2d2d;
    border-radius: 6px;
    padding: 12px;
    margin: 8px 0;
    overflow-x: auto;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 13px;
    line-height: 1.4;
}

.rich-text-message pre code {
    background: none;
    padding: 0;
    border-radius: 0;
    color: #f8f8f2;
    font-family: inherit;
    font-size: inherit;
}

/* Styles simples et propres pour Shiki - Mêmes couleurs que l'éditeur */
.rich-text-message .shiki-code-block {
    margin: 8px 0;
    height: 120px;
    max-height: 120px;
    overflow: hidden;
    border-radius: 8px;
    background: #2d2d2d;
}

.rich-text-message .shiki {
    background: #2d2d2d !important;
    color: #f8f8f2 !important;
    padding: 12px !important;
    border-radius: 8px !important;
    font-family: 'Consolas', 'Monaco', 'Ubuntu Mono', monospace !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    height: 120px !important;
    max-height: 120px !important;
    overflow-y: auto !important;
    overflow-x: auto !important;
    margin: 0 !important;
    box-sizing: border-box !important;
}

.rich-text-message .shiki code {
    background: none !important;
    padding: 0 !important;
    font-family: inherit !important;
    font-size: inherit !important;
    color: inherit !important;
    white-space: pre !important;
    display: block !important;
}

/* Styles pour highlight.js */
.hljs {
    display: block;
    overflow-x: auto;
    padding: 0.5em;
    background: #2d2d2d;
    color: #f8f8f2;
}

.hljs-comment,
.hljs-quote {
    color: #6a9955;
    font-style: italic;
}

.hljs-keyword,
.hljs-selector-tag,
.hljs-subst {
    color: #569cd6;
}

.hljs-number,
.hljs-literal,
.hljs-variable,
.hljs-template-variable,
.hljs-tag .hljs-attr {
    color: #b5cea8;
}

.hljs-string,
.hljs-doctag {
    color: #ce9178;
}

.hljs-title,
.hljs-section,
.hljs-selector-id {
    color: #dcdcaa;
}

.hljs-type,
.hljs-class .hljs-title {
    color: #4ec9b0;
}

.hljs-tag,
.hljs-name,
.hljs-attribute {
    color: #92c5f8;
    font-weight: normal;
}

.hljs-regexp,
.hljs-link {
    color: #d16969;
}

.hljs-symbol,
.hljs-bullet {
    color: #4ec9b0;
}

.hljs-built_in,
.hljs-builtin-name {
    color: #dcdcaa;
}

.hljs-meta {
    color: #9cdcfe;
}

.hljs-deletion {
    background: #420e09;
}

.hljs-addition {
    background: #0a4209;
}

.hljs-emphasis {
    font-style: italic;
}

.hljs-strong {
    font-weight: bold;
}

/* Styles pour TiptapEditor uniquement - Coloration syntaxique avec highlight.js */
.ProseMirror pre {
    background: #2d2d2d !important;
    border-radius: 0px !important;
    padding: 12px !important;
    margin: 0px !important;
    overflow-x: auto !important;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
    font-size: 13px !important;
    line-height: 1.4 !important;
    color: #f8f8f2 !important;
    border: none !important;
    box-shadow: none !important;
}

.ProseMirror pre code {
    background: none !important;
    padding: 0 !important;
    border-radius: 0 !important;
    color: inherit !important;
    font-family: inherit !important;
    font-size: inherit !important;
    display: block !important;
    white-space: pre !important;
    border: none !important;
    box-shadow: none !important;
}

/* Coloration syntaxique highlight.js pour TiptapEditor uniquement */
.ProseMirror .hljs-keyword {
    color: #c586c0 !important;
    font-weight: bold !important;
}

.ProseMirror .hljs-string {
    color: #ce9178 !important;
}

.ProseMirror .hljs-number {
    color: #b5cea8 !important;
}

.ProseMirror .hljs-comment {
    color: #6a9955 !important;
    font-style: italic !important;
}

.ProseMirror .hljs-function {
    color: #dcdcaa !important;
}

.ProseMirror .hljs-title {
    color: #dcdcaa !important;
}

.ProseMirror .hljs-variable {
    color: #9cdcfe !important;
}

.ProseMirror .hljs-class {
    color: #4ec9b0 !important;
}

.ProseMirror .hljs-tag {
    color: #569cd6 !important;
}

.ProseMirror .hljs-attribute {
    color: #92c5f8 !important;
}

.ProseMirror .hljs-property {
    color: #9cdcfe !important;
}

.ProseMirror .hljs-built_in {
    color: #dcdcaa !important;
}

.ProseMirror .hljs-operator {
    color: #d4d4d4 !important;
}

.ProseMirror .hljs-punctuation {
    color: #d4d4d4 !important;
}

/* S'assurer que les styles hljs s'appliquent correctement dans l'éditeur */
.ProseMirror .hljs {
    background: #2d2d2d !important;
    color: #f8f8f2 !important;
    display: block !important;
    overflow-x: auto !important;
    padding: 0.5em !important;
}

/* Règle finale pour les blocs de code Shiki dans les messages */
.rich-text-message .chat-code-block pre,
.rich-text-message .chat-code-block .shiki {
    max-height: 90px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    white-space: pre-wrap !important;
}
`, "",{"version":3,"sources":["webpack://./react/features/overlay-chat/components/OverlayChat.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,uDAAuD;IACvD,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uDAAuD;IACvD,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,0DAA0D;AAC1D;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,wDAAwD;IACxD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA,wEAAwE;AACxE;IACI,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,wBAAwB;IACxB,6BAA6B;IAC7B,sEAAsE;IACtE,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,+BAA+B;IAC/B,6BAA6B;IAC7B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;;;IAKI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,kFAAkF;AAClF;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,mEAAmE;IACnE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,+BAA+B;IAC/B,6BAA6B;IAC7B,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,oEAAoE;AACpE;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,2EAA2E;AAC3E;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA,gEAAgE;AAChE;;IAEI,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,gCAAgC;AACpC","sourcesContent":["/* Styles for rich text messages in overlay chat */\n.rich-text-message {\n    color: inherit;\n    line-height: 1.4;\n}\n\n.rich-text-message strong {\n    font-weight: bold;\n    color: inherit;\n}\n\n.rich-text-message em {\n    font-style: italic;\n    color: inherit;\n}\n\n.rich-text-message u {\n    text-decoration: underline;\n    color: inherit;\n}\n\n.rich-text-message code {\n    background-color: rgba(255, 255, 255, 0.1);\n    color: #ff6b6b;\n    padding: 2px 4px;\n    border-radius: 4px;\n    font-family: Monaco, Consolas, \"Courier New\", monospace;\n    font-size: 0.85em;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.rich-text-message pre {\n    background-color: rgba(0, 0, 0, 0.3);\n    color: #fff;\n    padding: 12px;\n    border-radius: 6px;\n    font-family: Monaco, Consolas, \"Courier New\", monospace;\n    font-size: 0.9em;\n    overflow: auto;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    margin: 8px 0;\n    white-space: pre-wrap;\n}\n\n.rich-text-message pre code {\n    background-color: transparent;\n    padding: 0;\n    border-radius: 0;\n    border: none;\n    color: inherit;\n}\n\n.rich-text-message ul, .rich-text-message ol {\n    padding: 0 0 0 20px;\n    margin: 8px 0;\n}\n\n.rich-text-message li {\n    margin: 2px 0;\n}\n\n.rich-text-message p {\n    margin: 0 0 8px 0;\n}\n\n.rich-text-message p:last-child {\n    margin-bottom: 0;\n}\n\n/* Styles pour la coloration syntaxique - Messages Shiki */\n.rich-text-message pre {\n    background: #2d2d2d;\n    border-radius: 6px;\n    padding: 12px;\n    margin: 8px 0;\n    overflow-x: auto;\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n    font-size: 13px;\n    line-height: 1.4;\n}\n\n.rich-text-message pre code {\n    background: none;\n    padding: 0;\n    border-radius: 0;\n    color: #f8f8f2;\n    font-family: inherit;\n    font-size: inherit;\n}\n\n/* Styles simples et propres pour Shiki - Mêmes couleurs que l'éditeur */\n.rich-text-message .shiki-code-block {\n    margin: 8px 0;\n    height: 120px;\n    max-height: 120px;\n    overflow: hidden;\n    border-radius: 8px;\n    background: #2d2d2d;\n}\n\n.rich-text-message .shiki {\n    background: #2d2d2d !important;\n    color: #f8f8f2 !important;\n    padding: 12px !important;\n    border-radius: 8px !important;\n    font-family: 'Consolas', 'Monaco', 'Ubuntu Mono', monospace !important;\n    font-size: 12px !important;\n    line-height: 1.4 !important;\n    height: 120px !important;\n    max-height: 120px !important;\n    overflow-y: auto !important;\n    overflow-x: auto !important;\n    margin: 0 !important;\n    box-sizing: border-box !important;\n}\n\n.rich-text-message .shiki code {\n    background: none !important;\n    padding: 0 !important;\n    font-family: inherit !important;\n    font-size: inherit !important;\n    color: inherit !important;\n    white-space: pre !important;\n    display: block !important;\n}\n\n/* Styles pour highlight.js */\n.hljs {\n    display: block;\n    overflow-x: auto;\n    padding: 0.5em;\n    background: #2d2d2d;\n    color: #f8f8f2;\n}\n\n.hljs-comment,\n.hljs-quote {\n    color: #6a9955;\n    font-style: italic;\n}\n\n.hljs-keyword,\n.hljs-selector-tag,\n.hljs-subst {\n    color: #569cd6;\n}\n\n.hljs-number,\n.hljs-literal,\n.hljs-variable,\n.hljs-template-variable,\n.hljs-tag .hljs-attr {\n    color: #b5cea8;\n}\n\n.hljs-string,\n.hljs-doctag {\n    color: #ce9178;\n}\n\n.hljs-title,\n.hljs-section,\n.hljs-selector-id {\n    color: #dcdcaa;\n}\n\n.hljs-type,\n.hljs-class .hljs-title {\n    color: #4ec9b0;\n}\n\n.hljs-tag,\n.hljs-name,\n.hljs-attribute {\n    color: #92c5f8;\n    font-weight: normal;\n}\n\n.hljs-regexp,\n.hljs-link {\n    color: #d16969;\n}\n\n.hljs-symbol,\n.hljs-bullet {\n    color: #4ec9b0;\n}\n\n.hljs-built_in,\n.hljs-builtin-name {\n    color: #dcdcaa;\n}\n\n.hljs-meta {\n    color: #9cdcfe;\n}\n\n.hljs-deletion {\n    background: #420e09;\n}\n\n.hljs-addition {\n    background: #0a4209;\n}\n\n.hljs-emphasis {\n    font-style: italic;\n}\n\n.hljs-strong {\n    font-weight: bold;\n}\n\n/* Styles pour TiptapEditor uniquement - Coloration syntaxique avec highlight.js */\n.ProseMirror pre {\n    background: #2d2d2d !important;\n    border-radius: 0px !important;\n    padding: 12px !important;\n    margin: 0px !important;\n    overflow-x: auto !important;\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;\n    font-size: 13px !important;\n    line-height: 1.4 !important;\n    color: #f8f8f2 !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.ProseMirror pre code {\n    background: none !important;\n    padding: 0 !important;\n    border-radius: 0 !important;\n    color: inherit !important;\n    font-family: inherit !important;\n    font-size: inherit !important;\n    display: block !important;\n    white-space: pre !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n/* Coloration syntaxique highlight.js pour TiptapEditor uniquement */\n.ProseMirror .hljs-keyword {\n    color: #c586c0 !important;\n    font-weight: bold !important;\n}\n\n.ProseMirror .hljs-string {\n    color: #ce9178 !important;\n}\n\n.ProseMirror .hljs-number {\n    color: #b5cea8 !important;\n}\n\n.ProseMirror .hljs-comment {\n    color: #6a9955 !important;\n    font-style: italic !important;\n}\n\n.ProseMirror .hljs-function {\n    color: #dcdcaa !important;\n}\n\n.ProseMirror .hljs-title {\n    color: #dcdcaa !important;\n}\n\n.ProseMirror .hljs-variable {\n    color: #9cdcfe !important;\n}\n\n.ProseMirror .hljs-class {\n    color: #4ec9b0 !important;\n}\n\n.ProseMirror .hljs-tag {\n    color: #569cd6 !important;\n}\n\n.ProseMirror .hljs-attribute {\n    color: #92c5f8 !important;\n}\n\n.ProseMirror .hljs-property {\n    color: #9cdcfe !important;\n}\n\n.ProseMirror .hljs-built_in {\n    color: #dcdcaa !important;\n}\n\n.ProseMirror .hljs-operator {\n    color: #d4d4d4 !important;\n}\n\n.ProseMirror .hljs-punctuation {\n    color: #d4d4d4 !important;\n}\n\n/* S'assurer que les styles hljs s'appliquent correctement dans l'éditeur */\n.ProseMirror .hljs {\n    background: #2d2d2d !important;\n    color: #f8f8f2 !important;\n    display: block !important;\n    overflow-x: auto !important;\n    padding: 0.5em !important;\n}\n\n/* Règle finale pour les blocs de code Shiki dans les messages */\n.rich-text-message .chat-code-block pre,\n.rich-text-message .chat-code-block .shiki {\n    max-height: 90px !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    white-space: pre-wrap !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
